import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";

const Repeatability_Report_Table = ({ data, currentPage, setCurrentPage }) => {
  const itemsPerPage = 10;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const maxObservations = Math.max(
    ...(data?.data?.map(
      (row) => row?.Selection_Type_Record_Observations?.length || 0,
    ) || [0]),
  );

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowSpan="2">Sr.No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Test Method</th>
                <th rowSpan="2">sample Id</th>
                <th rowSpan="2">Test Type</th>
                <th rowSpan="2">Certified Value</th>
                <th rowSpan="2">Checked By</th>
                 <th rowSpan="2">Remark</th>

                {maxObservations > 0 && (
                  <th colSpan={maxObservations} className="text-center">
                    Observations
                  </th>
                )}

                <th rowSpan="2">Avg.</th>
                <th rowSpan="2">SD</th>
                <th rowSpan="2">RSD%</th>
              </tr>

              {maxObservations > 0 && (
                <tr>
                  {Array.from({ length: maxObservations }).map((_, i) => (
                    <th key={i}>OBS {String(i + 1).padStart(2, "0")}</th>
                  ))}
                </tr>
              )}
            </thead>

            <tbody>
              {data?.data?.length > 0 ? (
                data?.data?.map((row, index) => {
                  const observations =
                    row?.Selection_Type_Record_Observations || [];

                  return (
                    <tr key={row.id || index}>
                      <td>
                        {(currentPage - 1) *
                          (data?.per_page || data?.data?.length || 0) +
                          index +
                          1}
                      </td>
                      <td>{formatDate(row?.date) || "-"}</td>
                      <td>{row?.Test_Method?.name || "-"}</td>
                      <td>{row?.Sample_Management?.unique_id || "-"}</td>
                      <td>{row?.Test_Type?.name || "-"}</td>
                      <td>{row?.certified_value || "-"}</td>
                      <td>{row?.User?.name || "-"}</td>
                      <td>{row?.remark || "-"}</td>

                      {Array.from({ length: maxObservations }).map((_, i) => (
                        <td key={i}>
                          {observations[i]?.observation_value || "-"}
                        </td>
                      ))}

                      <td>{row?.average || "-"}</td>
                      <td>{row?.std_deviation || "-"}</td>
                      <td>{row?.rsd || "-"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p>
            Showing {(currentPage - 1) * (data?.per_page || 0) + 1} to{" "}
            {Math.min(currentPage * (data?.per_page || 0), data?.total || 0)} of{" "}
            {data?.total || 0} entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={data?.current_page}
            totalPages={data?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Repeatability_Report_Table;
